import React from "react";
import AuthModalHeader from "./auth/AuthModalHeader";
import AuthForm from "./auth/AuthForm";
import AuthProviders from "./auth/AuthProviders";
import AuthFooter from "./auth/AuthFooter";
// import HCaptcha from "@hcaptcha/react-hcaptcha";
import { ResponsiveModal } from "./ResponsiveModal/ResponsiveModal";

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  mode: "login" | "signup";
  onModeChange: (mode: "login" | "signup") => void;
}

const AuthModal: React.FC<AuthModalProps> = ({
  isOpen,
  onClose,
  mode,
  onModeChange,
}) => {
  const [captchaToken, setCaptchaToken] = React.useState<string | null>(null);
  const captchaRef = React.useRef(null);

  const onLoad = () => {
    captchaRef.current.execute();
  };

  // React.useEffect(() => {
  //   if (captchaToken) console.log(`hCaptcha Token: ${captchaToken}`);
  // }, [captchaToken]);

  return (
    <ResponsiveModal
      open={isOpen}
      onOpenChange={onClose}
      title="Sign In"
      className="bg-gradient-to-br from-deep-indigo to-deep-indigo/90 border-holo-blue/20 text-white max-w-md mx-auto"
    >
      <div>
        <AuthModalHeader mode={mode} />

        <AuthForm mode={mode} onModeChange={onModeChange} onClose={onClose} />

        {/* <HCaptcha
          ref={captchaRef}
          sitekey="2620db56-477c-4e0a-a8ce-04aad14cc298"
          size="invisible"
          onLoad={onLoad}
          onVerify={(token) => {
            setCaptchaToken(token);
          }}
        /> */}

        <AuthProviders mode={mode} />

        <AuthFooter
          mode={mode}
          onModeChange={onModeChange}
          onClose={onClose}
          loading={false}
        />
      </div>
    </ResponsiveModal>
  );
};

export default AuthModal;
